<template>
  <v-app id="app">
    <component :is="layout">
      <router-view :layout.sync="layout" />
    </component>
    <!-- <app-navigation></app-navigation>

    <v-content transition="slide-x-transition">
      <router-view></router-view>
    </v-content>
    <v-footer color="indigo" app>
      <span class="white--text"
        >&copy; 2019 - {{ current_year }} Gambia Ports Authority</span
      >
    </v-footer> -->
  </v-app>
</template>

<script>
import AppNavigation from "@/components/AppNavigation";
import "vuejs-noty/dist/vuejs-noty.css";
import "sweetalert2/dist/sweetalert2.min.css";
import moment from "moment";
export default {
  name: "App",
  components: {
    AppNavigation
  },
  data: () => ({
    current_year: moment().format("YYYY"),
    layout: "div"
  })
};
</script>
